import { Box, Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

type DeleteRecurringAvailabilityModalProps = {
  onClose: () => void;
  onDeleteSeries: () => void;
  onDeleteThisDay: () => void;
};

const DeleteRecurringAvailabilityModal = ({
  onClose,
  onDeleteSeries,
  onDeleteThisDay,
}: DeleteRecurringAvailabilityModalProps) => {
  return (
    <Modal
      aria-label="Delete this availability?"
      open={true}
      onOpenChange={(open) => !open && onClose()}
      dividers
      header={
        <Heading fontFamily="heading-alt" level={4}>
          Delete this availability?
        </Heading>
      }
      body={
        <Box data-testid="DeleteRecurringAvailabilityModal">
          <Paragraph>
            This availability repeats over multiple days. You can delete just this day or the entire series.
          </Paragraph>
        </Box>
      }
      footer={
        <ButtonGroup aria-label="Modal actions">
          <TextButton data-testid="DeleteRecurringAvailabilityModal-DeleteSeriesBtn" onClick={onDeleteSeries}>
            Delete series
          </TextButton>
          <Button
            data-testid="DeleteRecurringAvailabilityModal-DeleteThisDayBtn"
            emphasis="filled"
            onClick={onDeleteThisDay}
          >
            Delete this day
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default DeleteRecurringAvailabilityModal;
